import React, { useEffect } from 'react';
import './SavedCardsModal.css';
import { useTranslation } from 'react-i18next';
//Components
import PaymentMethodButton from '../PaymentMethodButton/PaymentMethodButton';

const SavedCardsModal = ({ onSelectCard, selectedCard, savedCards = [], isOpen, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="saved-cards-modal">
        <div className="indicator"></div>
        <div className="saved-cards-header">
          <h2>{t('packages.selectCard')}</h2>
        </div>

        <div className="saved-cards-list">
          {savedCards.map((card) => (
            <PaymentMethodButton
              key={card.id}
              method={card}
              isSelected={selectedCard === card.id}
              onClick={() => onSelectCard(card.id)}
              defaultPayment={card.is_default}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default SavedCardsModal;
